export default "__VITE_ASSET__DurBEGiF__"